import { section } from '@/neon';

import carousel from '@/components/carousel';
import productItem from '@/components/productItem';
import scrollIntoView from '@/lib/scrollIntoView';
import orderCarouselItems from '@/lib/orderCarouselItems';

const selectors = {
  carouselContainer: '.featured-collection-row__slides',
  animatedSlides: '.animates',
  products: '.product-item',
};

section('featured-collection-row', {
  onLoad() {
    this.animatedSlides = this.container.querySelectorAll(
      selectors.animatedSlides
    );
    this.carouselContainer = this.container.querySelector(
      selectors.carouselContainer
    );

    this.carousel = carousel(this.container);

    const products = this.container.querySelectorAll(selectors.products);
    this.productItems = [];

    products.forEach(element => {
      this.productItems.push(productItem(element));
    });

    if (this.animatedSlides.length) {
      this._initScrollAnimation(
        orderCarouselItems(this.container, this.animatedSlides)
      );
    }
  },

  _initScrollAnimation(items) {

    // If the caorusle is inline the animation needs to delay
    // to account for text-block fade in.
    const animationDelay = 750;

    this.scrollAnimation = scrollIntoView(
      this.container,
      items,
      animationDelay
    );
  },

  onBlockSelect({ target: slide }) {
    this.carousel.goToSlide(slide.dataset.index);
  },

  onUnload() {
    this.carousel.unload();

    this.productItems.forEach(item => item.unload());

    if (this.animatedSlides.length) {
      this.scrollAnimation.unload();
    }
  },
});
